module.exports = __webpack_public_path__ + "img/2-Recording.c26b1c83.gif";